import { push } from 'connected-react-router';
import qs from 'query-string';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { compose } from 'recompact';

import type { UnifiedEvent } from 'src/app/analytics/analyticsEvents';
import { loggedInPromoOnboardingPage, shop } from 'src/app/router/paths';
import { redirectToOnboarding, onboardingAccountValidate, segmentTrack } from 'src/app/state/actions';
import {
  REDIRECT_POST_ONBOARDING,
  setPromoCodeForOnboarding,
  setPromoOnboardingHasExistingAccount,
  setPromoOnboardingZipCode,
} from 'src/app/state/actions/promoPageSignUp';
import {
  getCurrentPathParams,
  getPromoOnboardingDefaultZipCode,
  getPromoOnboardingEmployeeType,
  getPromoOnboardingRedirect,
} from 'src/app/state/selectors';
import type { Dispatch } from 'src/app/state/store';

import { MultiReferralPromo, NON_CREDIT_PROMOS } from '../constants';

import { Renderer } from '.';

const makeMapStateToProps = (state, ownProps) => {
  const defaultZipCode = getPromoOnboardingDefaultZipCode(state);
  const promoCode = ownProps.promoCode;
  const isNonCreditPromo = NON_CREDIT_PROMOS.includes(promoCode);
  const pathParams = qs.parse(getCurrentPathParams(state));
  return {
    checkZipCodeEligibility: state.client.checkZipCodeEligibility,
    defaultZipCode,
    postOnboardingRedirect: getPromoOnboardingRedirect(state),
    hideFields: promoCode === 'free-advil' || promoCode === 'try-capsule-for-free',
    shouldDisplayZipCode: defaultZipCode === null,
    employeeDescription: getPromoOnboardingEmployeeType(state),
    isNonCreditPromo,
    isSinglePromoReferral: !!MultiReferralPromo[promoCode],
    promoReferral: pathParams['referral'],
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  validateData: data => dispatch(onboardingAccountValidate(data)),
  redirectToPostOnboardingRedirect: postOnboardingRedirect =>
    dispatch(push(REDIRECT_POST_ONBOARDING[postOnboardingRedirect] ?? shop.toPath())),
  redirectToPromoOnboardingSteps: () => dispatch(push(loggedInPromoOnboardingPage.toPath())),
  segmentTrack: (event: UnifiedEvent, payload) => dispatch(segmentTrack(event, payload)),
  dispatchSetPromoOnboardingZipCode: (zipCode: number) => dispatch(setPromoOnboardingZipCode(zipCode)),
  dispatchSetPromoOnboardingHasExistingAccount: (hasExistingAccount: boolean) =>
    dispatch(setPromoOnboardingHasExistingAccount(hasExistingAccount)),
  dispatchSetPromoCodeForOnboarding: (promoCode: string) => dispatch(setPromoCodeForOnboarding(promoCode)),
  onRedirectToOnboarding: (promoCode: string) =>
    dispatch(redirectToOnboarding(`Promo Landing Page`, { referral: promoCode })),
});

const connector = connect(makeMapStateToProps, mapDispatchToProps);
export type PropsFromRedux = ConnectedProps<typeof connector>;

export const SignUpForm = compose(connector)(Renderer);
